import { IOutstandingOrdersFilter } from 'api/swaggerTypes';
import HyperLinkCell from './HyperLink';
import { COLUMN_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';

const DATAGRIDCONSTANTS = {
    header: {
        Product: COLUMN_SIZE.lg0,
        Quantity: 92,
        Price: 152,
        Discount: 87,
        Total: 152,
        Description: 278,
    }
};

export const SUBTITLE = 'Select invoice lines to include in the Credit note';

const ORDER_STATUS = {
    a: 'All',
    1: 'Incomplete',
    2: 'Active',
    3: 'On hold'
};

export const ParseOrderStatus = (status: IOutstandingOrdersFilter['OrderStatus']) => ORDER_STATUS?.[status] ?? '';

export const columns = [
    {
        dataField: 'ProductIdDisplay',
        caption: 'Product',
        width: DATAGRIDCONSTANTS.header.Product,
        allowResizing: false,
        fixed: true,
        cellComponent: HyperLinkCell,
    },

    {
        dataField: 'QuantityDisplay',
        caption: 'Quantity',
        width: DATAGRIDCONSTANTS.header.Quantity,
        allowResizing: false,
        alignment: 'right',
    },
    {
        dataField: 'PriceDisplay',
        caption: 'Price',
        width: DATAGRIDCONSTANTS.header.Price,
        allowSorting: false,
        allowEditing: false,
        allowResizing: true,
        alignment: 'right',
    },
    {
        dataField: 'DiscountDisplay',
        caption: 'Discount',
        width: DATAGRIDCONSTANTS.header.Discount,
        allowResizing: true,
        alignment: 'right',
    },
    {
        dataField: 'TotalDisplay',
        caption: 'Total',
        width: DATAGRIDCONSTANTS.header.Total,
        allowResizing: false,
        alignment: 'right',
    },
    {
        dataField: 'Description',
        caption: 'Description',
        width: DATAGRIDCONSTANTS.header.Description,
        allowResizing: true,
    }
];
